const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
}[character]))

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

export const highlightText = (value, keyword) => {
  const text = String(value ?? '')
  const normalizedKeyword = String(keyword ?? '').trim()
  if (!normalizedKeyword) return escapeHtml(text)

  const expression = new RegExp(escapeRegExp(normalizedKeyword), 'gi')
  let lastIndex = 0
  let highlighted = ''
  text.replace(expression, (match, index) => {
    highlighted += escapeHtml(text.slice(lastIndex, index))
    highlighted += `<mark class="search-keyword">${escapeHtml(match)}</mark>`
    lastIndex = index + match.length
    return match
  })
  return highlighted + escapeHtml(text.slice(lastIndex))
}

// Preserve existing rich-text elements by replacing only matched text nodes.
export const highlightElement = (element, keyword) => {
  const normalizedKeyword = String(keyword ?? '').trim()
  if (!element || !normalizedKeyword) return

  element.querySelectorAll('mark.search-keyword').forEach((mark) => {
    mark.replaceWith(document.createTextNode(mark.textContent || ''))
  })
  element.normalize()

  const expression = new RegExp(escapeRegExp(normalizedKeyword), 'gi')
  const textNodes = []
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement
      if (!node.nodeValue.trim() || !parent || ['MARK', 'SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) {
        return NodeFilter.FILTER_REJECT
      }
      return NodeFilter.FILTER_ACCEPT
    }
  })

  while (walker.nextNode()) textNodes.push(walker.currentNode)

  textNodes.forEach((node) => {
    const text = node.nodeValue
    expression.lastIndex = 0
    if (!expression.test(text)) return

    expression.lastIndex = 0
    const fragment = document.createDocumentFragment()
    let lastIndex = 0
    text.replace(expression, (match, index) => {
      if (index > lastIndex) fragment.append(document.createTextNode(text.slice(lastIndex, index)))
      const mark = document.createElement('mark')
      mark.className = 'search-keyword'
      mark.textContent = match
      fragment.append(mark)
      lastIndex = index + match.length
    })
    if (lastIndex < text.length) fragment.append(document.createTextNode(text.slice(lastIndex)))
    node.parentNode.replaceChild(fragment, node)
  })
}
